import React from 'react';

import { ControlledAccordion } from '@nerdwallet/react-accordion';

import _ from 'lodash';
import { useControlPanelAccordionToggle } from './hooks/use-control-panel-accordion-toggle';
import useAnalytics from '../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../lib/analytics/trackers';

const FORM_NAME = 'controlPanel';

export type AccordionItem = {
  header: string;
  children: React.ReactNode;
};

type Props = {
  items: AccordionItem[];
  className?: string;
};

const ControlPanelAccordion = ({ items, className }: Props): JSX.Element => {
  const segmentAbstract = useAnalytics();
  const { activeIndex, setActiveIndex } = useControlPanelAccordionToggle({
    formName: FORM_NAME,
    fieldName: 'header',
    items,
  });

  const accordionItems = items.map((item, index) => ({
    title: item.header,
    expanded: activeIndex === index,
    onSelect: () => {
      if (activeIndex !== index) {
        // segment analytics
        debouncedTrackInputEvent(
          {
            field: _.startCase(_.toLower(item.header)), // title case
            entityName: 'form_field_section',
            field_type: 'expand-contract',
            field_value: 'expand',
          },
          segmentAbstract
        );
      }

      setActiveIndex(index);
    },
    children: item.children,
  }));

  return <ControlledAccordion items={accordionItems} className={className} />;
};

export default ControlPanelAccordion;
